import { Injectable, Type } from '@angular/core';
import { IDynamicComponent } from './interfaces';

export class DynamicComponentRegistryService {

  private _componentTypes: { [type: string]: Type<IDynamicComponent> } = {};

  private defaultComponentType?: Type<IDynamicComponent>;

  get componentTypes(): { [type: string]: Type<IDynamicComponent> } {
    return this._componentTypes;
  }

  setDefault(componentType: Type<IDynamicComponent>): void {
    this.defaultComponentType = componentType;
  }

  register(type: string, componentType: Type<IDynamicComponent>): void {
    this._componentTypes[type] = componentType;
  }

  has(type: string): boolean {
    return this._componentTypes.hasOwnProperty(type);
  }

  getType(type: string): Type<IDynamicComponent> | undefined {
    if (this.has(type)) {
      return this._componentTypes[type];
    }
    return this.defaultComponentType;
  }
}


export class DefaultDynamicComponentRegistryService extends DynamicComponentRegistryService {
  constructor() {
    super();
  }
}
